import { SubscriptionForm } from 'components/subscription/components';
import { Image } from 'components/ui-kit';
import { Container } from 'components/ui-kit/grid';
import { SubscriptionTag, carrotService } from 'lib';
import { useCallback, type JSX } from 'react';
import styles from './quiz-email.module.scss';
import { Box } from '../../components/box';

type TQuizEmailViewProps = {
  onSuccess: VoidFunction;
};

export const QuizEmailView = ({
  onSuccess,
}: TQuizEmailViewProps): JSX.Element => {
  const handleSubscribe = useCallback(async (email: string) => {
    return carrotService.subscribePromo(email, SubscriptionTag.BUSINESSDAY24);
  }, []);

  return (
    <Container>
      <Box className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.title}>
            Почти всё&nbsp;&mdash; оставьте почту, чтобы увидеть результат!
          </h1>
          <Image
            className={styles.image}
            src="/images/collaborations/utkonos/email.svg"
            alt="Утконос"
          />
          <div className={styles.content}>
            <SubscriptionForm
              onSubscribe={handleSubscribe}
              afterSubscribedHandler={onSuccess}
            />
          </div>
        </div>
      </Box>
    </Container>
  );
};
